import { useMutation } from "@tanstack/react-query";
import axios from "axios";
import { v4 as uuid } from "uuid";

import { SalesforceChatConfig } from "../types/chat";

interface CreateConversationInput {
  accessToken: string;
}

interface ConversationResult {
  conversationId: string;
}

export function useCreateConversation(config: SalesforceChatConfig) {
  return useMutation<ConversationResult, Error, CreateConversationInput>({
    mutationFn: async ({ accessToken }) => {
      const url = `${config.scrtUrl}/iamessage/api/v2/conversation`;

      const conversationId = uuid();

      const body = {
        conversationId,
        routingAttributes: {},
        esDeveloperName: config.esDeveloperName,
      };

      await axios.post(url, body, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json",
        },
      });

      return { conversationId };
    },
  });
}
